<style>
  .plus-icon {
    width: inherit;
    height: inherit;
    cursor: pointer;
  }
</style>

<svg fill="none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 30 30" class="plus-icon">
  <path d="M15 0a15 15 0 100 30 15 15 0 000-30zm7.5 16h-6.4v6.5a1 1 0 11-2.2 0v-6.4H7.5a1 1 0 010-2.2h6.4V7.5a1 1 0 012.2 0v6.4h6.4a1 1 0 110 2.2z" fill="#FB6B38"/>
</svg>